import React from "react";
import { ChevronRight } from "lucide-react";
import styles from "./EntityDetails.module.scss";

// nodes: [{ key, type, icon, name, isCurrent, onClick }] in ancestor -> current order
// "type" (Client/Portfolio/Program/Project) is shown as a hover tooltip - the icon
// already communicates the level, so keeping it out of the visible pill keeps it neat.
const HierarchyChain = ({ nodes }) => {
  if (!nodes || nodes.length === 0) return null;

  return (
    <div className={styles.chain}>
      {nodes.map((node, index) => (
        <React.Fragment key={node.key}>
          {index > 0 && (
            <span className={styles.chainArrow}>
              <ChevronRight size={14} />
            </span>
          )}
          <div
            className={`${styles.chainNode} ${node.isCurrent ? styles.chainNodeCurrent : ""} ${
              node.onClick ? styles.chainNodeClickable : ""
            }`}
            onClick={node.onClick}
            title={node.type}
          >
            <span className={styles.chainIcon}>{node.icon}</span>
            <span className={styles.chainName}>{node.name}</span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default HierarchyChain;
